<template>
    <section class="block-blog-de">
        <div class="container">
            <div class="section-header">
                <h4 class="headline-xlg text-centered">Was Sie noch interessieren könnte</h4>
            </div>
            <div class="wrapper">
                <div>
                    <a v-for="(post, index) in posts" :key="index" :href="post.link" :target="openInNewWindow">
                        <span :class="'text-default cat-'+post.categories[post.categories.length - 1]" v-html="post.parent_category"></span>
                        <h3 class="headline-xs" v-html="post.title.rendered"></h3>
                        <div v-html="post.excerpt.rendered"></div>
                    </a>
                </div>
                <div>
                    <figure>
                        <img
                            src="imgs/web/img_blog_person.webp"
                            srcset="imgs/web/img_blog_person.webp 1x, imgs/web/img_blog_person@2x.webp 2x"
                            alt="Vitadio - Was interessiert andere User*innen?"
                        />
                    </figure>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    export default {
        props: {

        },
        data() {
            return {
                posts: []
            }
        },
        created() {
            this.fetchPosts()
        },
        computed: {
            openInNewWindow() {
                let uri = new URI(location.href)

                if(uri.domain() === 'abnehmenmitdiabetes.de') {
                    return '_blank'
                } else {
                    return '_self'
                }
            }
        },
        methods: {
            fetchPosts() {
                var instance = axios.create();
                delete instance.defaults.headers.common['X-CSRF-TOKEN']
                delete instance.defaults.headers.common['X-Requested-With']

                instance.get(`https://vitadio.de/ratgeber/wp-json/wp/v2/posts?orderby=meta_value&meta_key=featured`).then((r) => {
                    var posts = r.data.filter(item => (item.acf.featured !== ''))
                    this.posts = _.orderBy(posts, 'acf.featured', 'asc');
                })
            }
        }
    }
</script>
